import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IApisLoginResponse } from '../../../entity/interface/iAuthApis';

export interface ILoginWithTokenUseCase {
    execute(
        username: string,
        agent: string,
        grantType: string,
        token: string,
        identityToken: string
    ): Promise<IApisLoginResponse>;
}

export class LoginWithTokenUseCase implements ILoginWithTokenUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        username: string,
        agent: string,
        grantType: string,
        token: string,
        identityToken: string
    ): Promise<IApisLoginResponse> {
        return await this.userRepo.loginWithToken(username, agent, grantType, token, identityToken);
    }
}
